import React from 'react';

class Footer extends React.Component {
    render() {
        return <div className="container">
            <div className="row">
                <div className="col-lg-2 order-last order-lg-0 footer-copyright d-flex justify-content-center">
                    <ul>
                        <li><img src={process.env.PUBLIC_URL + "/images/logo_white.svg"} className="logo-gjeldsregisteret-white" alt="Gjeldsregisteret AS logo"></img></li>
                        <li><p className="copyright">© Gjeldsregisteret.com</p></li>
                    </ul>

                </div>
                <div className="col-lg-3 d-flex justify-content-center">
                    <ul>
                        <li className="li-header text-center text-lg-left">Gjeldsregisteret AS</li>
                        <li className="text-center text-lg-left">&nbsp;</li>

                    </ul>
                </div>
                <div className="col-lg-3 d-flex justify-content-center">
                    <ul>
                        <li className="li-header text-center text-lg-left">Besøksadresse</li>
                        <li className="text-center text-lg-left">Snarøyveien 20, 1360 Fornebu</li>
                    </ul>
                </div>

                <div className="col-lg-3 d-flex justify-content-center">
                    <ul>
                        <li className="li-header text-center text-lg-left">Postadresse</li>
                        <li className="text-center text-lg-left">Postboks 4, 1330 Fornebu</li>
                    </ul>
                </div>
            </div>
        </div>
    }
}

export default Footer;